<template>
  <div class="qcc-bidding-container">
    <!-- 查询表单 -->
    <el-card shadow="never" class="search-card" style="margin-bottom: 15px;">
      <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="handleSearch()">
        <el-form-item label="项目编号" prop="projectNo">
          <el-input
              v-model="dataForm.projectNo"
              placeholder="请输入项目编号"
              clearable
              size="small"              style="width: 200px;"
          />
        </el-form-item>
        <el-form-item label="项目名称" prop="projectName">
          <el-input
              v-model="dataForm.projectName"
              placeholder="请输入项目名称"
              clearable
              size="small"              style="width: 200px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch()">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 招投标排查历史记录表格 -->
    <el-card shadow="never" class="history-card" style="margin-bottom: 20px;">
      <div slot="header" class="card-header">
        <span>历史记录</span>
      </div>
      <el-table
          :data="biddingList"
          border
          stripe          style="width: 100%;"
          v-loading="listLoading"
          size="small"
          :max-height="270"
          @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40" align="center"></el-table-column>
        <el-table-column prop="projectNo" label="项目编号" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150" :formatter="formatDateColumn"></el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
                type="primary"
                size="mini"
                icon="el-icon-document"
                @click="viewInvestigationReport(scope.row)">
              查看报告
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"          style="margin-top: 15px; text-align: right;">
      </el-pagination>
    </el-card>

    <el-divider content-position="left">招投标风险排查</el-divider>


    <!-- 招投标风险排查表单 -->
    <div class="bidding-form-container" style="display: flex; gap: 20px; align-items: flex-start;">
      <!-- 左侧表单 -->
      <div class="form-section" style="flex: 1;">
        <el-form :model="dataForm" size="small" label-width="100px">
          <el-form-item label="供应商信息" prop="companyKeys" :rules="[{ required: true, message: '请输入供应商信息', trigger: 'blur' }]">
            <el-input
                type="textarea"
                :rows="6"
                v-model="dataForm.companyKeys"
                placeholder="请输入供应商名称或统一社会信用代码，每行一个"                style="width: 100%;"
            />
            <div class="tip-text" style="margin-top: 5px; color: red; font-size: 12px;">
              支持输入企业名称或统一社会信用代码，每行输入一个，至少输入两家公司，至多二十家公司
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitBiddingScan" :loading="submitLoading">提交排查</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 右侧排查结果 -->
      <div class="result-section" v-if="showResult" style="flex: 1; max-width: 500px;">
        <el-card shadow="hover" class="result-card">
          <div slot="header" class="result-header">
            <span>排查结果</span>
          </div>
          <div class="result-summary">
            <div class="summary-item">
              <span class="label">排查编号：</span>
              <span class="value">{{ resultData.tenderNo }}</span>
            </div>
            <div class="summary-item">
              <span class="label">项目编号：</span>
              <span class="value">{{ resultData.projectNo }}</span>
            </div>
            <div class="summary-item">
              <span class="label">项目名称：</span>
              <span class="value">{{ resultData.projectName }}</span>
            </div>
            <div class="summary-item">
              <span class="label">创建时间：</span>
              <span class="value">{{ formatDate(resultData.createDate) }}</span>
            </div>
          </div>
          <div class="report-actions" style="margin-top: 20px; text-align: center;">
            <el-button type="primary" @click="viewInvestigationReport(resultData)" size="small">查看招投标排查报告</el-button>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 招投标排查报告弹窗 -->
    <el-dialog title="招投标排查报告" :visible.sync="reportDialogVisible" width="90%" append-to-body>
      <div style="height: 80vh;">
        <iframe id="reportIframe" ref="reportIframe" frameborder="0" style="width: 100%; height: 100%;" allowfullscreen></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { biddingScanRisk, getSign, selectBidding } from '@/controller/supplier';

export default {
  name: 'QccBidding',
  data() {
    return {
      dataForm: {
        projectNo: '',
        projectName: '',
        companyKeys: ''
      },
      // 表格相关
      biddingList: [],
      listLoading: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      // 其他
      submitLoading: false,
      showResult: false,
      resultData: {},
      reportDialogVisible: false,
      currentReportData: {}
    }
  },
  created() {
    this.getBiddingList();
  },
  methods: {
    /** 获取招投标排查列表 */
    async getBiddingList() {
      this.listLoading = true;
      try {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          projectNo: this.dataForm.projectNo,
          projectName: this.dataForm.projectName
        };

        const response = await selectBidding(params);
        if (response && response.code === '00') {
          const pageData = response.body;
          this.biddingList = pageData.records || [];
          this.total = pageData.total || 0;
        } else {
          this.$message.error(response.msg || '查询失败');
        }
      } catch (error) {
        console.error('查询招投标排查列表失败:', error);
        this.$message.error('查询失败');
      } finally {
        this.listLoading = false;
      }
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.dataForm = {
        projectNo: '',
        projectName: '',
        companyKeys: ''
      };
      this.pageNo = 1;
      this.showResult = false;
      this.getBiddingList();
    },

    /** 搜索按钮操作 */
    handleSearch() {
      this.pageNo = 1;
      this.getBiddingList();
    },

    /** 分页大小改变 */
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBiddingList();
    },

    /** 当前页改变 */
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getBiddingList();
    },

    /** 表格多选变化 */
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    /** 载入招投标数据到表单 */
    loadBiddingData(record) {
      this.dataForm.projectNo = record.projectNo;
      this.dataForm.projectName = record.projectName;
      this.$message.success('已载入历史排查数据，可重新提交排查');
      // 滚动到表单位置
      this.$nextTick(() => {
        document.querySelector('.el-form').scrollIntoView({ behavior: 'smooth' });
      });
    },

    /** 提交招投标风险排查 */
    async submitBiddingScan() {
      if (!this.dataForm.projectNo.trim()) {
        this.$message.warning('请输入项目编号');
        return;
      }

      if (!this.dataForm.projectName.trim()) {
        this.$message.warning('请输入项目名称');
        return;
      }

      if (!this.dataForm.companyKeys.trim()) {
        this.$message.warning('请输入供应商信息');
        return;
      }

      // 解析供应商信息
      const companyKeys = this.dataForm.companyKeys.split('\n')
          .map(key => key.trim())
          .filter(key => key.length > 0);

      if (companyKeys.length === 0) {
        this.$message.warning('请至少输入一个有效的供应商信息');
        return;
      }

      this.submitLoading = true;

      try {
        const params = {
          projectNo: this.dataForm.projectNo,
          projectName: this.dataForm.projectName,
          companyKeys: companyKeys
        };

        const response = await biddingScanRisk(params);

        if (response && response.code === '00') {
          this.resultData = response.body;
          this.resultData.biddingId = response.body.id;
          this.showResult = true;
          this.$message.success('招投标风险排查提交成功');
          // 刷新列表
          this.getBiddingList();
        } else {
          this.$message.error(response.msg || '提交失败');
        }
      } catch (error) {
        console.error('招投标风险排查失败:', error);
        this.$message.error('提交失败');
      } finally {
        this.submitLoading = false;
      }
    },

    /** 查看招投标排查报告 */
    viewInvestigationReport(record) {
      this.currentReportData = record;
      this.reportDialogVisible = true;

      // 等待弹窗渲染完成后再加载 iframe 内容
      this.$nextTick(() => {
        this.loadInvestigationReport();
      });
    },

    /** 加载招投标排查报告 */
    async loadInvestigationReport() {
      try {
        // 调用后端 API 获取签名信息
        const signResponse = await getSign({});
        if (signResponse && signResponse.code === '00') {
          const {timestamp, sign} = signResponse.body;

          // 使用固定配置参数（实际应用中可能需要从系统配置中获取）
          const phone = '13863182271';
          const accessKey = 'PHCiakFKnnbCtwiYxpArTK25hz3xJj8G';

          // 从当前记录获取必要参数
          const id = this.currentReportData.biddingId;

          // 招投标排查详情 URL
          const redirectUrl = `https://kys.qcc.com/external/supplier/bidding-investigation/detail?id=${id}`;
          const fallbackUrl = 'https://kys.qcc.com/error/403';
          const host = 'https://kys.qcc.com';
          const url = `${host}/rover/account/loginRedirect?phone=${encodeURIComponent(phone)}&accessKey=${encodeURIComponent(accessKey)}&timestamp=${encodeURIComponent(timestamp)}&sign=${encodeURIComponent(sign)}&redirectUrl=${encodeURIComponent(redirectUrl)}&fallbackUrl=${encodeURIComponent(fallbackUrl)}`;

          const iframe = this.$refs.reportIframe;
          if (iframe) {
            iframe.src = url;
          }
        } else {
          this.$message.error('获取签名失败');
        }
      } catch (error) {
        console.error('加载招投标排查报告失败:', error);
        this.$message.error('加载招投标排查报告失败');
      }
    },

    /** 格式化日期 */
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (e) {
        return dateString;
      }
    },

    /** 表格列日期格式化 */
    formatDateColumn(row, column, cellValue, index) {
      if (!cellValue) return '';
      try {
        const date = new Date(cellValue);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (e) {
        return cellValue;
      }
    }
  }
}
</script>
<style scoped>
.qcc-bidding-container {
  padding: 15px;
}

.tip-text {
  color: #999;
  font-size: 12px;
}

.search-card {
  margin-bottom: 15px;
}

.history-card {
  margin-bottom: 20px;
}

.card-header {
  font-weight: bold;
  font-size: 14px;
}

.bidding-form-container {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.form-section {
  flex: 1;
}

.result-section {
  flex: 1;
  max-width: 500px;
}

.result-card {
  background-color: #f5f7fa;
}

.result-header {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}

.result-summary {
  padding: 10px;
}

.summary-item {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.summary-item:last-child {
  margin-bottom: 0;
}

.summary-item .label {
  font-weight: bold;
  min-width: 100px;
  color: #606266;
}

.summary-item .value {
  flex: 1;
  color: #303133;
}

.report-actions {
  margin-top: 20px;
  text-align: center;
}
</style>

